<template>
    <div
        class="align-center"
        style="
            width: 100%;
            padding: 40px 0px;
            background: #2d2d2d;
            margin-top: 20px;
        "
    >
        <div class="container column screen-width" style="gap: 16px">
            <div class="row" style="gap: 24px">
                <p>
                    주소 : 부산광역시 남구 지게골로 50 (문현동 351-30) (우)48456
                </p>
                <p>대표: 백운식</p>
                <p>사업자등록번호: 603-81-51724</p>
                <p>통신판매업신고번호: 제2014-부산남구-0298호</p>
                <p>개인정보관리책임자담당자 (sales@kumhomarine.com)</p>
            </div>

            <!-- 고객센터 영역 -->
            <div id="customer-center" class="column" style="">
                <div class="row" style="gap: 16px">
                    <div class="row" style="gap: 8px">
                        <Phone :size="18"></Phone>
                        <p>051-293-8589 내선 1번</p>
                    </div>
                    <div class="row" style="gap: 8px">
                        <p style="font-weight: bold">FAX</p>
                        <p>051-265-8984</p>
                    </div>
                </div>

                <div class="row" style="gap: 16px">
                    <div class="row" style="gap: 8px">
                        <p style="font-weight: bold">평일</p>
                        <p>오전 09:00 ~ 오후 17:00</p>
                    </div>

                    <div class="row" style="gap: 8px">
                        <p style="font-weight: bold">점심</p>
                        <p>오후 12:00 ~ 오후 13:00</p>
                    </div>

                    <div class="row" style="gap: 8px">
                        <p style="font-weight: bold">휴무</p>
                        <p>토 / 일 / 공휴일</p>
                    </div>
                </div>
            </div>

            <div
                class="screen-width"
                style="height: 1px; background: white; margin: 16px 0px"
            ></div>

            <div>
                <p>
                    본 사이트에서 게시되는 상품들은 금호마린테크 외 타
                    쇼핑몰에서 판매하는 상품이 포함되어 있습니다.
                </p>

                <p>
                    타 쇼핑몰 판매 상품의 경우 금호마린테크(주) 통신판매의
                    당사자가 아니므로, 해당 상품, 거래 정보 및 거래 등에 대해
                    책임을 지지 않습니다.
                </p>
                <p>
                    본 사이트의 모든 콘텐츠는 저작권법의 보호를 받는 바, 무단
                    전재, 복사, 배포 등을 금합니다.
                </p>
            </div>
            <!-- sns 영역 -->
            <div id="sns" class="row" style="gap: 16px">
                <ul class="row" style="list-style: none">
                    <li class="column align-center">
                        <a
                            class="column align-center"
                            href="https://www.youtube.com/@kumhomarine2058"
                            target="_blank"
                        >
                            <span>
                                <img :src="youtubeIcon" class="profile-image" />
                            </span>
                            <span><p style="font-size: 10px">유투브</p></span>
                        </a>
                    </li>
                    <li class="column align-center">
                        <a
                            class="column align-center"
                            href="https://www.instagram.com/kumhomarine_lowrance_korea/"
                            target="_blank"
                        >
                            <span>
                                <img
                                    :src="instargramIcon"
                                    class="profile-image"
                                />
                            </span>
                            <span
                                ><p style="font-size: 10px">인스타그램</p></span
                            >
                        </a>
                    </li>
                    <li class="column align-center">
                        <a
                            class="column align-center"
                            href="http://pf.kakao.com/_FNNwT"
                            target="_blank"
                        >
                            <span>
                                <img :src="kakaoIcon" class="profile-image" />
                            </span>
                            <span><p style="font-size: 10px">카카오톡</p></span>
                        </a>
                    </li>
                    <li class="column align-center">
                        <a
                            class="column align-center"
                            href="https://www.kumhomarine.com/"
                            target="_blank"
                        >
                            <span>
                                <img
                                    :src="kumhomarine_logo"
                                    class="profile-image"
                                />
                            </span>
                            <span
                                ><p style="font-size: 10px">
                                    금호마린테크
                                </p></span
                            >
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Phone from "vue-material-design-icons/Phone.vue";
import youtubeIcon from "@/assets/img/youtubeIcon.avif";
import instargramIcon from "@/assets/img/instargramIcon.avif";
import kakaoIcon from "@/assets/img/kakaoIcon.avif";
import kumhomarine_logo from "@/assets/kumhomarine_logo.png";

export default {
    name: "footer-layout",
    components: {
        Phone,
    },
    data() {
        return { youtubeIcon, instargramIcon, kakaoIcon, kumhomarine_logo };
    },
};
</script>

<style scoped>
p {
    font-size: 12px;
    font-weight: 400;
    color: white;
}
.container {
    color: white;
}

.profile-image {
    border-radius: 50%; /* 원형 모양을 만듭니다 */
    object-fit: contain; /* 이미지가 컨테이너를 꽉 채우도록 합니다 */
    background: white;
    padding: 8px;
    width: 36px; /* 이미지의 너비를 설정합니다 */
    height: 36px; /* 이미지의 높이를 설정합니다 */
}

li {
    width: 60px;
}
</style>
